import { ReactElement } from 'react';
import { IAuthProviderConfig } from '../../../IAuthProviderConfig.types';
import { IAuthProviderUiProps } from '../../../IAuthProviderUiProps.types';
import { useAssentlyProvider } from '../hooks/useAssentlyProvider';
import styles from './BankIdLogin.module.scss';
import LoginWithBankIdSVG from './assets/login-with-bankid.svg?react';

const defaultLabel = 'Logg inn med BankID';

export type IBankIdLoginProps = IAuthProviderUiProps & {
  onCanceled: IAuthProviderConfig['onCanceled'];
  serviceSourceUrl: string;
};

export const BankIdLogin = ({
  label = defaultLabel,
  onStart,
  onSuccess,
  onError,
  onCanceled,
  axoApiUrl,
  serviceSourceUrl,
}: IBankIdLoginProps): ReactElement => {
  const { authenticate } = useAssentlyProvider({
    onSuccess,
    onError,
    onCanceled,
    onStart,
    axoApiUrl,
    serviceSourceUrl,
  });

  return (
    <button
      type="button"
      onClick={authenticate}
      className={styles.bankIdLogin}
      data-testid="bankid-login"
    >
      <LoginWithBankIdSVG />
    </button>
  );
};
